import { Eye, EyeSlash, MagnifyingGlass } from '@phosphor-icons/react'
import clsx from 'clsx'
import { ErrorMessage, Field, useField } from 'formik'
import React, { useState } from 'react'

interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement|HTMLTextAreaElement> {
    className?: string;
    type?: string;
    value?: string;
    name?: string;
    inputType?: string;
    isSearch?: boolean;
    label?: string;
    borderRadius?: string;
    pwdIconTopClass?: string;
}

const TextField = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, TextFieldProps>(({ className = '', type = 'text', value = '', name='', inputType='', isSearch=false, borderRadius='rounded-full', pwdIconTopClass='', ...rest}, ref) =>  {
    const [show, setShow] = useState(false)

    const inputClass = clsx(
        'my-4',
        inputType === 'input' ? borderRadius : 'rounded-[1.5rem] resize-none',
        'text-base border border-gray bg-grayFill text-lg placeholder:text-lg py-3 px-6 text-off-black placeholder-gray focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary w-full transition-all duration-100 ease-in-out mb-3',
        className
      )
      
    return (
        <div className="relative w-full tracking-normal">
            {rest.label && (
                <div className='-mb-3.5'>
                    <label>{rest.label}</label>
                </div>
            )}
            {inputType === 'textarea' ? (
                <div className="relative">
                    <textarea
                        {...rest}
                        className={inputClass}
                    />
                </div>
            ) : (
                <div className="relative flex flex-col">
                    {isSearch && (
                        <div className='absolute left-2 top-[28px]'>
                            <MagnifyingGlass size={24} color='#85C349' />
                        </div>
                    )}
                    <Field ref={ref} name={name} type={show ? 'text' : inputType} className={`${inputClass} ${show ? '' : 'pr-10'} ${isSearch && 'pl-9'}`} {...rest} />
                    {inputType === 'password' && (
                        <div className={`absolute top-7 right-3 ${pwdIconTopClass}`}>
                            {show ? <Eye color='#6B6B6B' size={20} onClick={() => setShow(!show)} /> : <EyeSlash color='#6B6B6B' size={20} onClick={() => setShow(!show)} />}
                        </div>
                    )}
                </div>
            )}
        </div>
    )
})

export default TextField